
import { } from "element-ui";
import { Component, Prop, Ref, Vue, Watch, Emit } from "vue-property-decorator";
import { translations } from '@/mixins';
import Translations from '../../../Translations.vue';
import { mapGetters } from "vuex";
import { Select, Option } from "element-ui";
import {
  ValidationObserver,
  configure,
  ValidationProvider,
} from "vee-validate";
const ConceptMarketingProps = Vue.extend({
  props: {
    data: {
      type: Object,
      default: () => { },
    },
  },
});
export interface Language {
  value: string;
  text: string;
}
@Component({
  components: {
    Translations,
    [Select.name]: Select,
    [Option.name]: Option,
    ValidationProvider
  },
  computed: {
    ...mapGetters({
      getLocale: 'app/getLocale'
    })
  },
  mixins: [translations],
})
export default class ConceptMarketing extends ConceptMarketingProps {
  translate!: Function;
  public getLocale: any;
  temporaryURL: any = ""
  imageType: Number = 0;
  flagExtention: any = ""
  disImg: any = true;
  imageTypes: Array<Object> = [
    {
      value: 0,
      text: "Image URL",
    },
    {
      value: 1,
      text: "Upload Image",
    },
  ];
  // fileValue: any = null;
  abandonedCart: Boolean = true;
  // Data and computed properties go here as defined in your original code.

  languages: Language[] = [
    {
      value: 'en-us',
      text: 'English',
    },
    {
      value: 'ar-sa',
      text: 'Arabic',
    },
    {
      value: 'fr',
      text: 'French',
    },
  ];

  languages2: Language[] = [
    {
      value: '',
      text: 'None',
    },
    {
      value: 'en-us',
      text: 'English',
    },
    {
      value: 'ar-sa',
      text: 'Arabic',
    },
    {
      value: 'fr',
      text: 'French',
    },
  ];

  isLanguageSelected(value: string, selectedLanguage: string) {
    return value === selectedLanguage;
  }
  restaurantTypes: Array<Object> = [
    {
      value: 'fastfood',
      text: "Fastfood",
    },
    {
      value: 'burgers',
      text: "Burgers",
    },
    {
      value: 'chicken',
      text: "Chicken",
    },
    {
      value: 'shawarma',
      text: "Shawarma",
    },
    {
      value: 'pizza',
      text: "Pizza",
    },
    {
      value: 'healthy',
      text: "Healthy",
    },
    {
      value: 'coffee',
      text: "Coffee",
    },
    {
      value: 'bakery',
      text: "Bakery",
    },
  ];
  $notify: any;
  validTwitter: Boolean = true;
  validFacebook: Boolean = true;
  validInstagram: Boolean = true;
  validSnapchat: Boolean = true;

  @Watch("abandonedCart", { deep: true, immediate: true })
  onAbandonedCartChange(newValue: any) {
    if (!newValue) {
      this.data['abandoned-cart-alert'] = 0;
    }
  }

  @Watch("disImg", { deep: true, immediate: true })
  onCheckLogoURI(newValue: any) {
    if (!newValue) {
      if (!newValue['logo-uri']) {
        this.data['logo-uri'] = this.temporaryURL;
      }
    }
  }

  mounted() {
    this.abandonedCart = parseInt(this.data['abandoned-cart-alert']) > 0 ? true : false;
  }

  removeImage() {
    this.disImg = false;
    this.temporaryURL = this.data['logo-uri'];
    this.data['logo-uri'] = '';
  }

  checkValidUrl(url: string = '', social: string = '') {

    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

    setTimeout(() => {
      if (social == 'twitter') {
        /* @ts-ignore */
        if (!url.target._value) {
          this.validTwitter = true;
        } else {
          /* @ts-ignore */
          this.validTwitter = !!pattern.test(url.target._value);
        }
      }
      if (social == 'facebook') {
        /* @ts-ignore */
        if (!url.target._value) {
          this.validFacebook = true;
        } else {
          /* @ts-ignore */
          this.validFacebook = !!pattern.test(url.target._value);
        }
      }
      if (social == 'instagram') {
        /* @ts-ignore */
        if (!url.target._value) {
          this.validInstagram = true;
        } else {
          /* @ts-ignore */
          this.validInstagram = !!pattern.test(url.target._value);
        }
      }
      if (social == 'snapchat') {
        /* @ts-ignore */
        if (!url.target._value) {
          this.validSnapchat = true;
        } else {
          /* @ts-ignore */
          this.validSnapchat = !!pattern.test(url.target._value);
        }
      }
      /* @ts-ignore */
    }, 50);
  }


  checkSize(text: any) {
    if (this.getLocale === 'en_US') {
      if (text === 'The image field size must be less than 2000KB') {
        return 'The image file size must be less than 2MB'
      }
    }
    if (text === 'The image field size must be less than 2000KB') {
      return 'يجب أن يكون حجم ملف الصورة أقل من 2 ميغا بايت'
    }
  }

  filesUploadChange(event: any) {
    if (event.target.files[0]['name'].split('.').pop().toString() == 'png' || event.target.files[0]['name'].split('.').pop().toString() == 'PNG' || event.target.files[0]['name'].split('.').pop().toString() == 'jpg' || event.target.files[0]['name'].split('.').pop().toString() == 'JPG' || event.target.files[0]['name'].split('.').pop().toString() == 'JPEG' || event.target.files[0]['name'].split('.').pop().toString() == 'jpeg') {
      this.disImg = true;
      this.data['logo-uri'] = URL.createObjectURL(event.target.files[0]) ?? '';
      this.data['logo-image'] = event.target.files[0];
    } else {
      let extension = event.target.files[0]['name'].split('.').pop().toString();
      this.$notify({
        title: "FILE EXTENSION WARNING!",
        verticalAlign: "bottom",
        horizontalAlign: "left",
        message: `Please upload a valid extension! You are about to upload ${extension} extension.`,
        type: "warning",
        icon: "fas fa-bomb",
      });
      return;
    }
  }

}
